import VueCookies from 'vue-cookies'
import axios from 'axios'
import {
  LoginUpdate
} from './modules/login'
import onlyMessage from '@/pages/publicUtils/resetMessage.js'
import router from '../router'
import {
  setLogin,
  setLoginOut
} from "@/pages/publicUtils/setLogin";

const service = axios.create({
  // baseURL: process.env.NODE_ENV === 'development' ? '/api2' : process.env.VUE_APP_BASE_URL,
  baseURL: process.env.VUE_APP_BASE_URL,
  // baseURL: "https://www.duobihouse.com",
  timeout: 60000
})
service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
service.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest'

// 请求拦截
service.interceptors.request.use(config => {
  config.headers.Authorization = 'Bearer ' + VueCookies.get('ACCESS_TOKEN');
  // console.log("请求拦截", config);
  return config
}, error => {
  console.log('请求err：', error)
  Promise.reject(error)
})

// 响应拦截
service.interceptors.response.use(response => {
  let aloneDo = false
  // console.log(typeof response.config.data);
  if (typeof response.config.data === "string") {
    aloneDo = JSON.parse(response.config.data).aloneDo
  }
  // 某些接口需要单独处理错误判断
  if (aloneDo) return response.data
  // 统一处理
  if (response.data.isSuccess === 1) return response.data
  //抛出异常，进入axios的catch
  onlyMessage.error(response.data.message || '发生异常')
  return Promise.reject(response.data)
}, error => {
  console.log('拦截err：', error) // for debug
  handleCode(error.response)
  return Promise.reject(error)
})

// 状态码处理
function handleCode(res) {
  switch (res.status) {
    case 401:
      // 授权过期
      if (res.data == 'expired') {
        let obj = {
          accessToken: VueCookies.get('ACCESS_TOKEN'),
          refreshToken: VueCookies.get('REFRESH_TOKEN'),
        }
        LoginUpdate(obj).then(resData => {
          // console.log('重新获取token', resData);
          setLogin(resData.data[0]).then(() => {
            onlyMessage.warning('授权过期，重新加载...')
            setTimeout(() => {
              location.reload()
            }, 2000);
          })
        }).catch(err => {
          onlyMessage.error('服务器异常，请重新登录！')
          loginOut()
        })
        return
      }
      // 其他错误
      onlyMessage.error(res.data || '授权验证有误，请重新登录！')
      loginOut()
      break;
    default:
      onlyMessage.error('服务器异常')
      break;
  }
}
// 多次跳转登录页的问题
function loginOut() {
  if (VueCookies.get('ACCESS_TOKEN')) {
    // console.log('401', router.history.current);
    setLoginOut()
    setTimeout(() => {
      let newUrl = router.resolve({
        path: '/login',
        query: {
          redirect: router.history.current.fullPath,
        }
      });
      window.open(newUrl.href, "_self");
    }, 1500);
  }
}

export default service